<template>
  <div class="NavDesktop">
    <router-link
      :to="{ name: 'home' }"
      class="NavDesktop__logo"
      v-slot="{}"
    />
    <!-- NAV ITEMS -->
    <div
      v-for="(route, index) in componentNavItems"
      @click="openRoute(index)"
      :key="index"
    >
      <router-link
        :to="route.to"
        :id="`Testing__${route.title.replace(/ /g, '')}`"
        :class="['NavDesktop__route row row--align-center fs-14 fw-med uppercase', {
          'NavDesktop__route--selected fc-blue': $route.path.includes(route.to.name)
        }]"
        v-slot="{ href, navigate }"
        :custom="true"
      >
        <a
          :href="href"
          @click="navigate"
        >
          <i :class="`fa ${route.icon} fa-28 fa-3 fa--none`" />
          {{ route.title }}
        </a>
      </router-link>

      <transition name="NavDesktop__fade">
        <div
          v-if="route.subroutes && route.expanded"
          class="NavDesktop__subroutes"
        >
          <router-link
            v-for="(subroute, subrouteIndex) in route.subroutes"
            :key="subrouteIndex"
            :to="subroute.to"
            :class="['NavDesktop__subroute fs-14 capitalize', {
              'NavDesktop__subroute--selected': $route.name === subroute.to.name
            }]"
            v-slot="{ href, navigate }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
            >
              {{ subroute.title }}
            </a>
          </router-link>
        </div>
      </transition>
    </div>

    <!-- LOGOUT -->
    <router-link
      :to="{ name: 'logout' }"
      class="NavDesktop__route NavDesktop__route-logout row row--width-auto fc-light fs-14"
      v-slot="{ href, navigate }"
      custom
    >
      <a
        :href="href"
        @click="navigate"
      >
        LOG OUT
      </a>
    </router-link>

    <router-link
      v-if="isMaster"
      :to="{ name: 'sandbox' }"
      class="NavDesktop__route NavDesktop__route-release-notes row row--width-auto d-none-important fs-14"
      v-slot="{ href, navigate }"
      custom
    >
      <a
        :href="href"
        @click="navigate"
      >
        SANDBOX
      </a>
    </router-link>

    <router-link
      v-if="isMaster"
      :to="{ name: 'styleguide' }"
      class="NavDesktop__route NavDesktop__route-styleguide row row--width-auto d-none-important fs-14"
      v-slot="{ href, navigate }"
      custom
    >
      <a
        :href="href"
        @click="navigate"
      >
        STYLEGUIDE
      </a>
    </router-link>

    <!-- ACCOUNT MANAGER (client and desktop ONLY) -->
    <!-- The Mobile version is in mobile-home.vue -->
    <base-account-rep-display
      v-if="userIsClient && accountManager"
      :account-manager="accountManager"
    />

    <native-app-download-widget v-if="userIsClient" />
  </div>
</template>

<script>
// Helpers
import {
  Employee,
} from '../utils/api'
// Components
import BaseAccountRepDisplay from './base-account-rep-display.vue'
import NativeAppDownloadWidget from './native-app-download-widget.vue'

export default {
  name: 'NavDesktop',

  components: {
    BaseAccountRepDisplay,
    NativeAppDownloadWidget,
  },

  props: {
    // Used to display styleguide and release notes links
    isMaster: {
      type: Boolean,
      required: false,
      default: false,
    },
    navItems: {
      type: Array,
      required: true,
    },
    userIsClient: {
      type: Boolean,
      required: true,
    },
  },

  async created () {
    if (this.userIsClient) {
      this.getClientAccountManager()
    }

    const expandedIndex = this.componentNavItems.findIndex(item => item?.to?.name === "invoices")
    if (expandedIndex > -1) {
      this.openRoute(expandedIndex)
    }
  },

  data () {
    return {
      accountManager: null,
      componentNavItems: this.navItems,
    }
  },

  methods: {
    async getClientAccountManager () {
      try {
        const client = JSON.parse(localStorage.getItem('user')).client
        this.accountManager = (await Employee.get(client.account_manager_id)).data
      }
      catch (error) {
        this.captureSentryEvent(
          'Client Account Manager Fetch Error',
          {
            config: error.config,
            data: this.$data,
            details: error,
            props: this.$props,
            response: error.response,
          }
        )
        this.CError('Error loading account manager:', error)
      }
    },

    openRoute (index) {
      this.componentNavItems.forEach((item) => {
        this.$set(item, 'expanded', false)
      })
      this.$set(this.componentNavItems[index], 'expanded', true)
    },
  },
}
</script>

<style lang="sass">
.NavDesktop
  $block: &

  .fa
    font-size: rem(20px)
    width: rem(20px)

  &__logo
    background-image: url('../assets/logo.png')
    background-position: left
    background-repeat: no-repeat
    background-size: contain
    display: block
    height: rem(37px)
    margin-bottom: 1.5rem
    width: 100%

  &__route
    outline: none
    padding: rem(10px) 0
    white-space: nowrap

    &--selected
      .fa
        color: $branding

      #{$block}__route-link
        color: $branding

  &__route-logout
    opacity: .6

  &__route-release-notes,
  &__route-styleguide
    opacity: 0

  &__subroute
    color: $text-light
    height: rem(30px)
    outline: none
    padding-left: rem(47px)

    &--selected
      margin-left: rem(-8px)
      color: $text-dark
      &::before
        content: '\2022'
        color: $branding

  &__subroutes
    +flex($direction: column)

  @media #{$tablet-landscape-and-up}
    .fa
      margin-right: rem(22px)

    &__route-logout,
    &__route-release-notes,
    &__route-styleguide
      margin-left: rem(42px)

</style>
